import { render, staticRenderFns } from "./ContractDisputes.view.vue?vue&type=template&id=32d89805&"
import script from "./ContractDisputes.view.vue?vue&type=script&lang=js&"
export * from "./ContractDisputes.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32d89805')) {
      api.createRecord('32d89805', component.options)
    } else {
      api.reload('32d89805', component.options)
    }
    module.hot.accept("./ContractDisputes.view.vue?vue&type=template&id=32d89805&", function () {
      api.rerender('32d89805', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/contract/disputes/ContractDisputes.view.vue"
export default component.exports